var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption"},[_c('v-divider',{staticClass:"my-4"}),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.$t('original_currency_notification', {currency: _vm.currency})))]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.$t('original_currency_amount_notification', {
            currency: _vm.originalCurrency,
            price: _vm.$options.filters.priceFormat(_vm.originalAmount, _vm.originalCurrency),
        })))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }